import BinaryLegsComponent from './BinaryLegs.component';
import BinaryLegsEditor from './BinaryLegs.editor';
import { BinaryLegsProps, BinaryLegsEditorProps } from './BinaryLegs.types';
import { adaptBinaryLegsProps, adaptBinaryLegsEditorProps } from './BinaryLegs.adapter';
import { registerSkinnableComponent } from '../registry';
import { BinaryLegsSkinnable } from './BinaryLegsSkinnable';

// 스킨 가능한 컴포넌트로 등록
registerSkinnableComponent(BinaryLegsSkinnable);

// 일반 사용을 위한 기본 내보내기
export default BinaryLegsComponent;

// 명명된 내보내기
export { 
  BinaryLegsComponent,
  BinaryLegsEditor,
  adaptBinaryLegsProps,
  adaptBinaryLegsEditorProps
};

// 타입 내보내기
export type { 
  BinaryLegsProps, 
  BinaryLegsEditorProps 
}; 